export default __webpack_public_path__ + "static/media/three-number.989ce36e.svg";